import React from 'react'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import removeProjectAddressMutation from '../../queries/server/mutations/remove_project_addresses'
import editProjectLocalMutation from '../../queries/client_side/mutations/edit_project'

const ProjectLocationListItem = ({project_id, id, address, googleResult}) => {

    return (
        <Mutation mutation={removeProjectAddressMutation}>
            {(removeProjectAddressMutationFunc, {loading}) => (
                <div className="d-flex flex-row align-items-center justify-content-between border-bottom p-2">
                    <div className="d-flex flex-column">
                        <div className="d-flex flex-row align-items-center">
                            <FontAwesomeIcon color="#82ca9d" icon="map-marker-alt"/>
                            <p className="font-weight-light p-0 m-0 pl-2" style={{flex: 1}}>{address}</p>
                        </div>
                        <div className="d-flex flex-row align-items-center">
                            <small className="p-0 m-0" style={{flex: 1}}>{googleResult}</small>
                        </div>
                    </div>
                    <Mutation mutation={editProjectLocalMutation}>
                        {(editProjectLocalMutationFunc) => (
                            <Button
                                size="sm"
                                color="danger"
                                className="square-btn"
                                disabled={loading}
                                onClick={() => {
                                    removeProjectAddressMutationFunc({variables: {project_id, ids: [id]}})
                                        .then(({data}) => {
                                            editProjectLocalMutationFunc({variables: {data: data.removeProjectAddresses}})
                                            toast.success('Location Removed', {autoClose: 2000})
                                        })
                                        .catch(e => toast.error(e.message, {autoClose: false}))
                                }}
                            >
                                <FontAwesomeIcon color="#fff" icon="trash-alt"/>
                            </Button>
                        )}

                    </Mutation>
                </div>
                
            )}
        </Mutation>
    )

}

ProjectLocationListItem.propTypes = {
    project_id: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    address: PropTypes.string.isRequired,
    googleResult: PropTypes.string
}

export default ProjectLocationListItem